import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { VendorPartner } from "~/models/VendorPartner";

const paths = {
	index: "/vendors/vendor_partners"
};

type TIndex = () => SwrReturnType<VendorPartner[]>;
type ReturnType = {
	index: TIndex;
};

export const useVendorPartners = (): ReturnType => {
	const index: TIndex = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { data, mutate, error } = useSWR<VendorPartner[]>(paths.index);
		return {
			data: data ?? null,
			error,
			isLoading: !data && !error,
			mutate
		};
	};
	return { index };
};
